/* Recover stale saved product-image references from the exact product, never another model. */
(() => {
  const products = new Map();
  function recover(image) {
    if (!(image instanceof HTMLImageElement) || image.dataset.tsImageRecovery) return;
    const card = image.closest('article, [data-product-id], [data-product-card], .bmw-card');
    const link = image.closest('a[href*="/products/"]') || card?.querySelector('a[href*="/products/"]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    image.dataset.tsImageRecovery = 'pending';
    const handle = url.pathname.split('/products/')[1].split('/')[0];
    if (!products.has(handle)) {
      products.set(handle, fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', {credentials: 'same-origin'})
        .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(product => product.featured_image || product.images?.[0] || null));
    }
    products.get(handle).then(source => {
      if (!source) { image.dataset.tsImageRecovery = 'unavailable'; return; }
      const current = new URL(source, location.origin);
      if (current.pathname === new URL(image.src, location.origin).pathname) {
        image.dataset.tsImageRecovery = 'unavailable'; return;
      }
      current.searchParams.set('width', '800');
      image.removeAttribute('srcset');
      image.src = current.href;
      image.dataset.tsImageRecovery = 'updated';
    }).catch(() => { image.dataset.tsImageRecovery = 'unavailable'; });
  }
  document.addEventListener('error', event => recover(event.target), true);
  function check() {
    document.querySelectorAll('img').forEach(image => {
      if (image.complete && image.currentSrc && image.naturalWidth === 0) recover(image);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check, {once: true});
  else check();
})();
